import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createStaticVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/google-calendar.vue
var o = {
	name: "DtIconGoogleCalendar",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--google-calendar"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Google Calendar",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("<path d=\"M17.263 6.737H6.737v10.526h10.526V6.737z\" fill=\"#fff\"></path><path d=\"M17.263 22 22 17.263l-2.368-.404-2.369.404-.432 2.166.432 2.571z\" fill=\"#EA4335\"></path><path d=\"M2 17.263v3.158A1.58 1.58 0 0 0 3.579 22h3.158l.486-2.368-.486-2.369-2.58-.404L2 17.263z\" fill=\"#188038\"></path><path d=\"M22 6.737V3.579A1.58 1.58 0 0 0 20.421 2h-3.158c-.288 1.175-.432 2.04-.432 2.593 0 .555.144 1.27.432 2.144 1.048.3 1.837.45 2.369.45.53 0 1.32-.15 2.368-.45z\" fill=\"#1967D2\"></path><path d=\"M22 6.737h-4.737v10.526H22V6.737z\" fill=\"#FBBC04\"></path><path d=\"M17.263 17.263H6.737V22h10.526v-4.737z\" fill=\"#34A853\"></path><path d=\"M17.263 2H3.58A1.58 1.58 0 0 0 2 3.579v13.684h4.737V6.737h10.526V2z\" fill=\"#4285F4\"></path><path d=\"M8.896 14.903c-.393-.266-.666-.654-.814-1.168l.913-.376c.083.316.227.56.434.734.205.174.455.26.747.26.299 0 .556-.091.77-.273a.87.87 0 0 0 .322-.693.86.86 0 0 0-.339-.703c-.226-.181-.51-.272-.85-.272h-.528v-.904h.474c.292 0 .538-.079.738-.237a.78.78 0 0 0 .3-.649c0-.244-.09-.44-.268-.585a1.042 1.042 0 0 0-.68-.22c-.269 0-.482.071-.64.215a1.26 1.26 0 0 0-.345.527l-.904-.376c.12-.34.34-.64.662-.899.323-.259.734-.39 1.234-.39.37 0 .703.072.998.215.295.144.526.342.693.595.167.254.25.538.25.854 0 .322-.077.595-.233.818a1.606 1.606 0 0 1-.572.515v.054c.292.12.546.318.734.572a1.5 1.5 0 0 1 .287.921c0 .358-.09.678-.272.958-.182.28-.433.501-.752.662-.32.16-.679.242-1.077.242a2.232 2.232 0 0 1-1.282-.397zm5.61-4.532-1.003.725-.502-.76L14.8 9.038h.69v6.12h-.985V10.37z\" fill=\"#4285F4\"></path>", 8)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=google-calendar.js.map